import React from 'react';
import { Zap, Eye, ShieldCheck } from 'lucide-react';
export function MCPSection() {
  return <section className="py-24 px-6 md:px-12 lg:px-24 bg-white" data-id="element-983">
      <div className="max-w-7xl mx-auto" data-id="element-984">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-985">
          <div data-id="element-986">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 font-['Syne']" data-id="element-987">
              Interactive Context <br data-id="element-988" />
              Through MCP
            </h2>
            <p className="text-xl text-gray-600 font-light mb-8" data-id="element-989">
              By adopting the Model Context Protocol (MCP), Synthia is no longer
              a destination—Synthia works directly inside the tools your team already uses like Claude, ChatGPT,
             Gemini, Squirro, ServiceNow, Salesforce, etc.
            </p>

            <div className="space-y-6" data-id="element-990">
              <div className="flex gap-4" data-id="element-991">
                <div className="p-2 bg-blue-50 rounded-full h-fit" data-id="element-992">
                  <Zap className="w-5 h-5 text-[#0066FF]" data-id="element-993" />
                </div>
                <div data-id="element-994">
                  <h3 className="font-bold text-lg" data-id="element-995">
                    Real-Time Instruction Injection
                  </h3>
                  <p className="text-gray-600" data-id="element-996">
                    Your models receive a behavioral boost at the millisecond of
                    execution, not after the fact.
                  </p>
                </div>
              </div>

              

              <div className="flex gap-4" data-id="element-997">
                <div className="p-2 bg-blue-50 rounded-full h-fit" data-id="element-998">
                  <ShieldCheck className="w-5 h-5 text-[#0066FF]" data-id="element-999" />
                </div>
                <div data-id="element-1000">
                  <h3 className="font-bold text-lg" data-id="element-1001">Automated Governance</h3>
                  <p className="text-gray-600" data-id="element-1002">
                    The model receives enforcement at every checkpoint, ensuring
                    trust is built into every token spent.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative bg-gray-50 rounded-xl p-8 border border-gray-200 min-h-[400px] flex items-center justify-center" data-id="element-1003">
            {/* Abstract representation of MCP integration */}
            <div className="relative w-full max-w-sm" data-id="element-1004">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 blur-2xl opacity-20 rounded-full" data-id="element-1005"></div>
              <div className="relative bg-white p-6 rounded-lg shadow-xl border border-gray-100" data-id="element-1006">
                <div className="flex items-center gap-3 mb-4 border-b border-gray-100 pb-4" data-id="element-1007">
                  <div className="w-3 h-3 rounded-full bg-red-400" data-id="element-1008"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-1009"></div>
                  <div className="w-3 h-3 rounded-full bg-green-400" data-id="element-1010"></div>
                  <span className="ml-auto text-xs text-gray-400" data-id="element-1011">
                    Claude / ChatGPT / Gemini
                  </span>
                </div>
                <div className="space-y-3" data-id="element-1012">
                  <div className="flex gap-3" data-id="element-1013">
                    <div className="w-8 h-8 rounded-full bg-gray-200" data-id="element-1014"></div>
                    <div className="flex-1 bg-gray-100 rounded p-2 text-xs text-gray-500" data-id="element-1015">
                      Draft a response to the client regarding the merger...
                    </div>
                  </div>

                  {/* Synthia Injection */}
                  <div className="ml-11 p-3 bg-blue-50 rounded border border-blue-100 relative" data-id="element-1016">
                    <div className="absolute -left-3 top-3 w-3 h-[1px] bg-blue-200" data-id="element-1017"></div>
                    <div className="flex items-center gap-2 mb-2" data-id="element-1018">
                      <div className="w-4 h-4 rounded bg-[#0066FF] flex items-center justify-center text-[10px] text-white font-bold" data-id="element-1019">
                        S
                      </div>
                      <span className="text-xs font-bold text-[#0066FF]" data-id="element-1020">
                        Synthia Active
                      </span>
                    </div>
                    <div className="space-y-1" data-id="element-1021">
                      <div className="h-1.5 bg-blue-200 rounded w-3/4" data-id="element-1022"></div>
                      <div className="h-1.5 bg-blue-200 rounded w-1/2" data-id="element-1023"></div>
                    </div>
                  </div>

                  <div className="flex gap-3 flex-row-reverse" data-id="element-1024">
                    <div className="w-8 h-8 rounded-full bg-purple-100" data-id="element-1025"></div>
                    <div className="flex-1 bg-white border border-gray-200 rounded p-2 text-xs text-gray-600" data-id="element-1026">
                      Based on your corporate communication guidelines (Policy
                      4.2), here is a compliant draft...
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}